import {ALL_INFO_RETIREMENT_STEPS, ALL_INFO_STEPS, RETIRED_TYPE_CODE, SESSION_KEY} from '../../const/AppConst';
import {filterFamilyDocs, filterRibDoc, filterSecuDocs, filterSignDocs, getAdditionalData, hasUpdatedStepCart, isClosedProposition, isDoneProposition} from '../../utils/dataUtils';
import {activateStep, extractJwtToken, getSessionStorageValue} from '../../utils/utils';
import {
  IAdditionalData, IAdditionalOption, IConsent, IDocumentDetail, IExtractedRibInfo, IExtractedSecurityInfo, IInfoStep,
  IJwtToken, IPreContractDocument, IPropositionDetails,
  IUpdatedProposition, IUploadedDoc
} from '../model';
import {IUploadedDocument} from '../model/index';
import {updatePropositionStep} from '../../services/CustomerApiService';


export type AppAction =
  {
    type: 'LOGIN';
    id: string;
    jwt: string;
    isDemo: boolean;
    isConseiller: boolean;
  }
  | {
  type: 'INIT_LINK';
  jwt: string;
}
  | {
  type: 'SET_DEMO';
  isDemo: boolean;
}
  | {
  type: 'LOAD_PROPOSITION';
  proposition: IPropositionDetails;
  cartData?: string;
}
  | {
  type: 'UPDATE_STEPS';
  steps: IInfoStep[];
}
  | {
  type: 'NEXT_INFO_STEP';
  path: string;
  proposition?: IPropositionDetails | null;
  updatedProposition?: IUpdatedProposition | null;
  additionalData?: IAdditionalData | null;
}
  | {
  type: 'BACK_INFO_STEP';
  path: string;
  updatedProposition?: IUpdatedProposition;
}
  | {
  type: 'UPDATE_CONSENT';
  consent: IConsent;
}
  | {
  type: 'UPDATE_CURRENT_PROPOSITION';
  proposition: IPropositionDetails;
}
  | {
  type: 'EXTRACT_SECU_ATTEST';
  path?: string;
  socialSecurityDocuments: IUploadedDocument<IExtractedSecurityInfo>[];
}
  | {
  type: 'EXTRACT_RIB';
  path?: string;
  ribDocument: IUploadedDocument<IExtractedRibInfo> | null;
} | {
  type: 'UPLOAD_IDENTITY';
  path?: string;
  identityDoc: IUploadedDoc | null;
}
  | {
  type: 'LIST_PRE_CONTRACT_DOCUMENT';
  preContractDocuments: IPreContractDocument[];
} | {
  type: 'UPLOAD_FAMILY_DOCUMENT';
  familyDoc: IUploadedDoc[];
} | {
  type: 'INIT_SMS';
  sessionUid: string;
  phoneNumberSMS?: string;
} | {
  type: 'LIST_SIGNED_DOCUMENT';
  signedDocument: IUploadedDoc[];
} | {
  type: 'UPDATE_UPDATED_PROPOSITION';
  updatedProposition: IUpdatedProposition | null;
} | {
  type: 'VALIDATED_PROPOSITION';
  proposition: IPropositionDetails;
} | {
  type: 'SHOW_MODAL';
  showModal: boolean;
} | {
  type: 'ADD_ADDITIONAL_OPTION';
  additionals: IAdditionalOption[];
} | {
  type: 'LOGIN_RETIREMENT';
  id: string;
  jwt: string;
  isDemo: boolean;
  isConseiller: boolean;
} | {
  type: 'UPLOAD_DOCUMENTS';
  docs: IUploadedDoc[];
} | {
  type: 'UPDATE_UPDATED_DOCUMENTS';
  updatedDocuments: IDocumentDetail[];
};

export interface AppState {
  isAuthenticated: boolean;
  isDemo?: boolean;
  isConseiller?: boolean;
  lastStepPath: string | null;
  expiredToken: string | null;
  jwtToken: IJwtToken | null;
  proposition: IPropositionDetails | null;
  updatedProposition: IUpdatedProposition | null;
  additionalData: IAdditionalData | null;
  infoSteps: IInfoStep[];
  socialSecurityDocuments: IUploadedDocument<IExtractedSecurityInfo>[];
  ribDocument: IUploadedDocument<IExtractedRibInfo> | null;
  identityDoc: IUploadedDoc | null;
  preContractDocuments: IPreContractDocument[];
  familyDoc: IUploadedDoc[];
  sessionUid: string;
  signedDocument: IUploadedDoc[];
  validatedPropositionId: string | null;
  showModal: boolean;
  additionals: IAdditionalOption[];
  reviewMode: boolean;
  phoneNumberSMS: string;
  isRetired?: boolean;
  documents: IUploadedDoc[];
}

const initEmptyState: AppState = {
  isAuthenticated: false,
  expiredToken: null,
  jwtToken: null,
  proposition: null,
  infoSteps: [],
  updatedProposition: null,
  additionalData: null,
  socialSecurityDocuments: [],
  ribDocument: null,
  identityDoc: null,
  preContractDocuments: [],
  familyDoc: [],
  sessionUid: '',
  signedDocument: [],
  validatedPropositionId: null,
  showModal: false,
  additionals: [],
  reviewMode: false,
  phoneNumberSMS: '',
  lastStepPath: null,
  documents: [],
};

export const initialState = getSessionStorageValue(SESSION_KEY) ?? initEmptyState;


export function AppReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case 'LOGIN': {
      let newState = state;
      if (state.proposition?.propositionId !== action.id) {
        newState = initEmptyState;
      }
      return {
        ...newState,
        isAuthenticated: true,
        jwtToken: extractJwtToken(action.jwt),
        additionalData: null,
        proposition: null,
        preContractDocuments: [],
        infoSteps: [],
        isDemo: action.isDemo,
        isConseiller: action.isConseiller,
        socialSecurityDocuments: [],
        ribDocument: null,
        identityDoc: null,
        validatedPropositionId: null,
        showModal: false
      };
    }
    case 'INIT_LINK': {
      return {...state, isAuthenticated: false, expiredToken: action.jwt};
    }
    case 'LOAD_PROPOSITION': {
      if (action.cartData) {
        try {
          let cartState: AppState = JSON.parse(action.cartData);
          return {
            ...cartState,
            jwtToken: state.jwtToken,
            proposition: action.proposition,
            lastStepPath: cartState.lastStepPath,
            showModal: false,
            isDemo: state.isDemo,
            reviewMode: state.reviewMode,
            isConseiller: state.isConseiller
          }
        } catch (e) {
          console.log("error during parse cart data", e);
        }
      }

      return {
        ...state,
        proposition: action.proposition,
        updatedProposition: {
          retirementDate : action.proposition.contact?.retirementDate,
          civilityCode: action.proposition.contact.civilityCode,
          firstName: action.proposition.contact.firstName,
          lastName: action.proposition.contact.lastName,
          birthName: action.proposition.contact.birthName,
          birthPlace: action.proposition.contact.birthPlace,
          birthDate: action.proposition.contact.birthDate
            ? new Date(action.proposition.contact.birthDate).toISOString().slice(0, 10)
            : undefined,
          email: action.proposition.contact.email,
          familySituationCode: action.proposition.contact.familySituationCode?.toString(),
          phoneNumber: action.proposition.contact.phoneNumber,
          isForeignMobile: action.proposition.contact.isForeignMobile ?? false,
          attachmentOrganization: action.proposition.contact.attachmentOrganization,
          iban: action.proposition.iban,
          bankingHolder: action.proposition.bankingHolder,
          teletranmissionRefuse: action.proposition.contact.teletranmissionRefuse === 'true',
          beneficiaries: action.proposition.beneficiaries.map(el => {
            return {
              ...el,
              isConfirmed : true,
            }
          }),
          protectedAddress: false,
          protectedConditions: false,
          ribHolderConfirm: action.proposition.ribHolderConfirm,
          nir: action.proposition.contact?.nir,
          nirKey: action.proposition.contact?.nirKey,
          address: action.proposition.contact.address,
          postalCode: action.proposition.contact.postalCode,
          city: action.proposition.contact.city,
          countryId: action.proposition.contact.countryId,
          departmentCode: action.proposition.contact.departmentCode,
          lieudit: action.proposition.contact.lieudit,
          additionalAddress: action.proposition.contact.additionalAddress,
          buildingName: action.proposition.contact.buildingName,
          alsaceMoselleRegime: action.proposition.contact.alsaceMoselleRegime ? action.proposition.contact.alsaceMoselleRegime === 'true' : null,
          offerCode: action.proposition.offerCode,
          salaryIndex: action.proposition.salaryIndex,
          increasedIndex: action.proposition.increasedIndex,
          hasOldMutual: action.proposition.hasOldMutual,
          hasMgpInsurance: action.proposition.hasMgpInsurance,
          oldCompetitor: action.proposition.oldCompetitor,
          coveragesInfo: action.proposition.retiredCoveragesInfo,
          effectiveDate : action.proposition.effectiveDate
        },
        signedDocument: filterSignDocs(action.proposition),
        reviewMode: isDoneProposition(action.proposition) || isClosedProposition(action.proposition),
        ribDocument: filterRibDoc(action.proposition),
        socialSecurityDocuments: filterSecuDocs(action.proposition),
        familyDoc: filterFamilyDocs(action.proposition),
        additionalData: getAdditionalData(action.proposition)
      }
    }
    case 'SET_DEMO': {
      return {
        ...state,
        isDemo: action.isDemo
      }
    }
    case 'UPDATE_STEPS': {
      return {
        ...state,
        infoSteps: action.steps.length > 0 ? action.steps : state.infoSteps
      };
    }
    case 'BACK_INFO_STEP': {
      const previousProposition = state.proposition;
      const newState = {
        ...state,
        infoSteps: activateStep(action.path, state.infoSteps, state?.isRetired),
        updatedProposition: action.updatedProposition ? action.updatedProposition : state.updatedProposition,
        lastStepPath: action.path
      };
      const currentStep = previousProposition?.affiliationType === RETIRED_TYPE_CODE ? ALL_INFO_RETIREMENT_STEPS.find(step => step.path === action.path) : ALL_INFO_STEPS.find(step => step.path === action.path);
      if (currentStep && state.jwtToken && previousProposition && previousProposition.propositionId && hasUpdatedStepCart(previousProposition, currentStep)) {
        try {
          updatePropositionStep(state.jwtToken.accessToken, previousProposition.propositionId, {stepName: currentStep.code, cartData: JSON.stringify(newState)});
        } catch (e) {
          console.log("Error during update step data", e);
        }
      }

      return newState;
    }
    case 'NEXT_INFO_STEP': {
      const previousProposition = state.proposition;
      const newState = {
        ...state,
        infoSteps: activateStep(action.path, state.infoSteps),
        proposition: action.proposition ? action.proposition : state.proposition,
        updatedProposition: action.updatedProposition ? action.updatedProposition : state.updatedProposition,
        additionalData: action.additionalData ? action.additionalData : state.additionalData,
        lastStepPath: action.path
      };

      const currentStep = previousProposition?.affiliationType === RETIRED_TYPE_CODE ? ALL_INFO_RETIREMENT_STEPS.find(step => step.path === action.path) : ALL_INFO_STEPS.find(step => step.path === action.path);
      if (currentStep && state.jwtToken && previousProposition && previousProposition.propositionId && hasUpdatedStepCart(previousProposition, currentStep)) {
        try {
          updatePropositionStep(state.jwtToken.accessToken, previousProposition.propositionId, {stepName: currentStep.code, cartData: JSON.stringify(newState)});
        } catch (e) {
          console.log("Error during update step data", e);
        }
      }

      return newState;
    }
    case 'UPDATE_CURRENT_PROPOSITION': {
      return {
        ...state,
        proposition: action.proposition
      };
    }
    case 'EXTRACT_SECU_ATTEST': {
      const previousProposition = state.proposition;
      const newState = {
        ...state,
        socialSecurityDocuments: action.socialSecurityDocuments
      };

      const currentStep = previousProposition?.affiliationType === RETIRED_TYPE_CODE ? ALL_INFO_RETIREMENT_STEPS.find(step => step.path === state.lastStepPath) : ALL_INFO_STEPS.find(step => step.path === state.lastStepPath);
      if (currentStep && state.jwtToken && previousProposition && previousProposition.propositionId && hasUpdatedStepCart(previousProposition, currentStep)) {
        try {
          updatePropositionStep(state.jwtToken.accessToken, previousProposition.propositionId, {stepName: currentStep.code, cartData: JSON.stringify(newState)});
        } catch (e) {
          console.log("Error during update step data", e);
        }
      }

      return newState;
    }

    case 'EXTRACT_RIB': {
      const previousProposition = state.proposition;
      const newState = {
        ...state,
        ribDocument: action.ribDocument
      };

      const currentStep = previousProposition?.affiliationType === RETIRED_TYPE_CODE ? ALL_INFO_RETIREMENT_STEPS.find(step => step.path === state.lastStepPath) : ALL_INFO_STEPS.find(step => step.path === state.lastStepPath);
      if (currentStep && state.jwtToken && previousProposition && previousProposition.propositionId && hasUpdatedStepCart(previousProposition, currentStep)) {
        try {
          updatePropositionStep(state.jwtToken.accessToken, previousProposition.propositionId, {stepName: currentStep.code, cartData: JSON.stringify(newState)});
        } catch (e) {
          console.log("Error during update step data", e);
        }
      }

      return newState;
    }
    case 'UPLOAD_IDENTITY': {
      const previousProposition = state.proposition;
      const newState = {
        ...state,
        identityDoc: action.identityDoc
      };

      const currentStep = previousProposition?.affiliationType === RETIRED_TYPE_CODE ? ALL_INFO_RETIREMENT_STEPS.find(step => step.path === state.lastStepPath) : ALL_INFO_STEPS.find(step => step.path === state.lastStepPath);
      if (currentStep && state.jwtToken && previousProposition && previousProposition.propositionId && hasUpdatedStepCart(previousProposition, currentStep)) {
        try {
          updatePropositionStep(state.jwtToken.accessToken, previousProposition.propositionId, {stepName: currentStep.code, cartData: JSON.stringify(newState)});
        } catch (e) {
          console.log("Error during update step data", e);
        }
      }

      return newState;
    }
    case 'LIST_PRE_CONTRACT_DOCUMENT': {
      return {
        ...state,
        preContractDocuments: action.preContractDocuments
      };
    }
    case 'UPLOAD_FAMILY_DOCUMENT': {
      const previousProposition = state.proposition;
      const newState = {
        ...state,
        familyDoc: action.familyDoc
      };

      const currentStep = previousProposition?.affiliationType === RETIRED_TYPE_CODE ? ALL_INFO_RETIREMENT_STEPS.find(step => step.path === state.lastStepPath) : ALL_INFO_STEPS.find(step => step.path === state.lastStepPath);
      if (currentStep && state.jwtToken && previousProposition && previousProposition.propositionId && hasUpdatedStepCart(previousProposition, currentStep)) {
        try {
          updatePropositionStep(state.jwtToken.accessToken, previousProposition.propositionId, {stepName: currentStep.code, cartData: JSON.stringify(newState)});
        } catch (e) {
          console.log("Error during update step data", e);
        }
      }

      return newState;
    }
    case 'INIT_SMS': {
      return {
        ...state,
        sessionUid: action.sessionUid,
        phoneNumberSMS: action.phoneNumberSMS ? action.phoneNumberSMS : state.phoneNumberSMS
      };
    }
    case 'LIST_SIGNED_DOCUMENT': {
      return {
        ...state,
        signedDocument: action.signedDocument
      };
    }

    case 'UPDATE_UPDATED_PROPOSITION': {
      return {
        ...state,
        updatedProposition: action.updatedProposition
      };
    }
    case 'VALIDATED_PROPOSITION': {
      return {...state, proposition: action.proposition, validatedPropositionId: action.proposition.propositionId};
    }
    case 'SHOW_MODAL': {
      return {...state, showModal: action.showModal};
    }

    case 'ADD_ADDITIONAL_OPTION': {
      return {...state, additionals: action.additionals};
    }

    case 'LOGIN_RETIREMENT': {
      let newState = state;
      if (state.proposition?.propositionId !== action.id) {
        newState = initEmptyState;
      }
      return {
        ...newState,
        isAuthenticated: true,
        jwtToken: extractJwtToken(action.jwt),
        additionalData: null,
        proposition: null,
        preContractDocuments: [],
        infoSteps: [],
        isDemo: action.isDemo,
        isConseiller: action.isConseiller,
        socialSecurityDocuments: [],
        ribDocument: null,
        identityDoc: null,
        validatedPropositionId: null,
        showModal: false,
        isRetired: true
      };
    }

    case 'UPLOAD_DOCUMENTS': {
      return {
        ...state,
        documents: action.docs
      };
    }

    case 'UPDATE_UPDATED_DOCUMENTS': {

      return {
        ...state,
        proposition: {
          ...state.proposition,
          documents: action.updatedDocuments
        } as IPropositionDetails
      };
    }


    default:
      return state;
  }
}